import React from 'react';
import './footer.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {contacTitle} from "../demo_page/content";

class Footer extends React.Component {
    
  render() {
      const isEng = this.props.language && this.props.language === 'ENG';	
  	return (
      <div className={'footer-personalized'} id={'contact'}>
    		<section className="p-0">
           <div className="container-fluid">
           <div className="bottom-section">
              <div className="row">
                 <div className="col-md-6 p-0">
                    <div className="address-bar">
                       <div>
                           <h2 className="title">{isEng ? contacTitle.eng : contacTitle.hun}</h2>
                          <ul className="footer-style">
                              <li>
                                  <div className="footer-icon">
                                      <FontAwesomeIcon icon={['fas', 'address-card']} />
                                  </div>
                                  <div className="footer-address">
                                      <a href={null}>Appsint Informatikai Szolgáltató Kft.</a>
                                  </div>
                              </li>
                             <li>
                                <div className="footer-icon">
                                    <FontAwesomeIcon icon={['fas', 'map-marker-alt']} />
                                </div>
                                <div className="footer-address">
                                   <a href={null}>{isEng ? '47-49. Madarász Viktor Street, Budapest, 1138 Hungary' : '1138 Budapest, Madarász Viktor u 47-49.'}</a>
                                </div>
                             </li>
                             <li>
                                <div className="footer-icon">
                                    <FontAwesomeIcon icon={['fas', 'phone-rotary']} />
                                </div>
                                <div className="footer-address">
                                    <a href={null}>{'+36 70 649 9009'}</a>
                                </div>
                             </li>
                             <li>
                                <div className="footer-icon">
                                    <FontAwesomeIcon icon={['fas', 'envelope']} />
                                </div>
                                <div className="footer-address">
                                    <a href={null}>appsint@appsint.hu</a>
                                </div>
                             </li>
                             {/*<li>*/}
                             {/*   <div className="footer-icon">*/}
                             {/*       <FontAwesomeIcon icon={['fas', 'id-card']} />*/}
                             {/*   </div>*/}
                             {/*   <div className="footer-address">*/}
                             {/*       <a href={null}>Cégjegyzékszám: 01-09-978336</a>*/}
                             {/*   </div>*/}
                             {/*</li>*/}
                              <li>
                                  <div className="footer-icon">
                                      <FontAwesomeIcon icon={['fas', 'id-card']} />
                                  </div>
                                  <div className="footer-address">
                                      <a href={null}>{isEng ? 'VAT Number: ' : 'Adószám: '}23797637-2-41</a>
                                  </div>
                              </li>
                          </ul>
                       </div>
                    </div>
                 </div>
                 <div className="col-md-6 p-0">
                    <iframe title="google-map" src="https://maps.google.com/maps?q=Appsint%20Kft&t=&z=13&ie=UTF8&iwloc=&output=embed" allowFullScreen className="md-height"></iframe>
                 </div>
              </div>
           </div>
           </div>
        </section>

        <div className="copyright-section index-footer">
           <p>2020 Appsint Informatikai Szolgáltató Kft.</p>
        </div>

        <div className="tap-top">
           <div>
              <i className="fa fa-angle-double-up"></i>
           </div>
        </div>
        <div id="fb-root"></div>
        {/*Your customer chat code*/}
          <div className="fb-customerchat"
              page_id="2123438804574660"
              theme_color="#18e7d3"
              logged_in_greeting="Hi! Welcome to PixelStrap Themes  How can we help you?"
              logged_out_greeting="Hi! Welcome to PixelStrap Themes  How can we help you?">
          </div>
      </div>
  	);
  }
}


export default Footer;


// WEBPACK FOOTER //
// ./src/components/footer.js